import React from 'react';

type Quality = 'good' | 'fair' | 'poor' | null;

interface CallQualityIndicatorProps {
  quality: Quality;
  className?: string;
}

const BAR_COLORS: Record<NonNullable<Quality>, string> = {
  good: 'text-emerald-400',
  fair: 'text-yellow-400',
  poor: 'text-red-400',
};

const LABELS: Record<NonNullable<Quality>, string> = {
  good: 'Good call quality',
  fair: 'Fair call quality',
  poor: 'Poor call quality — check your connection',
};

/**
 * Three signal-bar icon reflecting live call quality via Twilio warning events.
 * Returns null when quality is null (not in a call or not yet determined).
 */
export function CallQualityIndicator({ quality, className = '' }: CallQualityIndicatorProps) {
  if (!quality) return null;
  const color = BAR_COLORS[quality];
  const label = LABELS[quality];
  const bars = quality === 'good' ? 3 : quality === 'fair' ? 2 : 1;

  return (
    <div
      className={`flex items-end gap-[2px] ${color} ${className}`}
      title={label}
      aria-label={label}
    >
      <div className={`w-1 rounded-sm bg-current ${bars >= 1 ? 'opacity-100' : 'opacity-25'}`} style={{ height: 6 }} />
      <div className={`w-1 rounded-sm bg-current ${bars >= 2 ? 'opacity-100' : 'opacity-25'}`} style={{ height: 10 }} />
      <div className={`w-1 rounded-sm bg-current ${bars >= 3 ? 'opacity-100' : 'opacity-25'}`} style={{ height: 14 }} />
    </div>
  );
}
